import request from "@/util/http";

export function sendCode(obj) {
  return request({
    url: '/upms/phone/code',
    method: 'put',
    params: obj
  })
}
